import { useInView } from './hooks/useInView';

const WEBON_SAMPLES = [
  { name: 'ZENIQ DEX', category: 'DEX' },
  { name: 'ZUSD Swap', category: 'Swap' },
  { name: 'ZENIQ Liquidity', category: 'DeFi' },
  { name: 'ZENIQ Arbitrage', category: 'Trading' },
  { name: 'ZenPass', category: 'Identity' },
  { name: 'Transfero Ramp', category: 'On-Ramp' },
  { name: 'COPPER ONE', category: 'Finance' },
  { name: 'Flaptron 3000', category: 'Gaming' },
];

const BENEFITS = [
  'Direct dApp interaction — no browser extensions',
  'No fragmented wallet switching between apps',
  'Faster execution with native wallet infrastructure',
  'Cleaner UX — integrated, not bolted on',
  'Access to an open, growing ecosystem of WebOns',
];

export default function WebOns() {
  const [ref, inView] = useInView();

  return (
    <section className="webons section--dark" id="webons" ref={ref}>
      <div className="container">
        <div className={`reveal ${inView ? 'in-view' : ''}`}>
          <div className="section-label">The Modular Web3 Layer</div>
          <h2 className="section-title section-title--lg" style={{ marginBottom: '2.5rem', maxWidth: '700px' }}>
            Fully compatible with <span className="gradient-text">WebOn Technology</span>
          </h2>
        </div>

        <div className="glass-wrap">
          <div className={`webons__inner stagger ${inView ? 'in-view' : ''}`}>
            <div className="webons__featured">
              <div className="webons__featured-icon">⬡</div>
              <div className="webons__featured-title">WebOn Technology</div>
              <div className="webons__featured-subtitle">Open Standard · Ecosystem-Compatible</div>
              <p className="webons__featured-desc">
                WebOns are decentralized mini-applications built on an open standard — independent
                of NOMO, but designed to run natively inside compatible hosts like the NOMO app.
                Each WebOn brings its own functionality while leveraging NOMO's wallet and
                infrastructure layers seamlessly.
              </p>

              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                {['Open Standard', 'Ecosystem-Native', 'Composable', 'Non-Custodial'].map((t) => (
                  <span className="tag" key={t}>{t}</span>
                ))}
              </div>

              <div className="webons__why">
                <div className="webons__why-title">Why WebOn Compatibility Matters</div>
                <p className="webons__why-text">
                  NOMO's full compatibility with the WebOn standard means users get direct access
                  to an open, growing ecosystem of decentralized applications — without switching
                  apps, extensions, or wallets.
                </p>
              </div>
            </div>

            <div className="webons__list">
              <div className="webons__count-bar">
                <span>Active WebOns</span>
                <strong>70+</strong>
              </div>

              {WEBON_SAMPLES.map((w) => (
                <div className="webon-item" key={w.name}>
                  <span className="webon-item__dot" />
                  <span className="webon-item__name">{w.name}</span>
                  <span className="webon-item__tag">{w.category}</span>
                </div>
              ))}

              <div className="webon-item" style={{ color: 'var(--gold)', fontStyle: 'italic', fontSize: '0.72rem', justifyContent: 'center' }}>
                + 60 more WebOns available
              </div>

              <div className="webons__benefits" style={{ marginTop: '1px' }}>
                {BENEFITS.map((b) => (
                  <div className="webons__benefit" key={b}>
                    <span className="webons__benefit-icon">◆</span>
                    <span>{b}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
